function SimplePage({ title, eyebrow, children, action }) {
  return (
    <main className="section public-simple-page">
      <div className="container-sm public-simple-card">
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p className="muted-text">{children}</p>
        {action}
      </div>
    </main>
  );
}

export default SimplePage;